if (document.getElementById('menuOpening')) {
    document.getElementById('menuOpening').onclick = () => {
       openMenu()
    }
}

function openMenu() {
    document.querySelector(".menu").classList.add("active")
}


if (document.getElementById('menuClosing')) {
    document.getElementById('menuClosing').onclick = () => {
       closeMenu()
    }
}

if (document.querySelector('.menu_bg')) {
    document.querySelector('.menu_bg').onclick = () => {
       closeMenu()
    }
}

function closeMenu() {
    if (document.querySelector('.menu.active')) {
        document.querySelector(".menu").classList.remove("active")
    }
}

let closeAboutWindowTimer

if (document.getElementById('aboutMenu')) {
    document.getElementById('aboutMenu').onmouseover = () => {
        openAboutWindow()
    }
    document.getElementById('aboutMenu').onmouseout = () => {
        closeAboutWindowTimer = setTimeout(() => {
            closeAboutWindow()
        }, 200)
    }
}

function openAboutWindow() {
    clearTimeout(closeAboutWindowTimer)
    document.getElementById("aboutWindow").classList.add("active")
}

function closeAboutWindow() {
    if (document.querySelector('.about-window.active')) {
        document.getElementById("aboutWindow").classList.remove("active")
    }
}

window.addEventListener('scroll', e => {
    closeAboutWindow();
})


$('.dropdown-link').click(function(e){
    e.preventDefault();
    $(this).parent().toggleClass('open')
})

